/**
 * Check if passed value is type of Object.
 *
 * @param {unknown} value Value to check.
 * @returns {boolean}
 */
export function isObject(value) {
    return Boolean(value && typeof value === 'object' && !Array.isArray(value));
}
